module.exports = __webpack_public_path__ + "img/sp11.459aa60f.png";